export default {"src":"/_next/static/media/jpg-svgrepo-com.4b60345f.svg","height":303,"width":303,"blurWidth":0,"blurHeight":0};